/**
 * Standalone Task 2 optional Skip preparation during prep phase.
 * Phase D owner-approved for Trial + Full Exam; standalone uses /task-two route.
 */
export function isSupportedTask2SkipPrepPath(pathname?: string): boolean {
  const path =
    pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  return path === '/task-two';
}
